export enum ToValidateStatus {
    New
}       
       
